<template>
    <b-container fluid>
        <page-title>
            <h2>
                <router-link :to="{ name: 'InvoiceList' }" class="nav-link">Faktury sprzedażowe</router-link>/Edycja/{{ retrieved.fullNumber }}
            </h2>
        </page-title>

        <div class="col page-element">
            <div v-if="retrieveError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ retrieveError }}</div>
            <div v-if="updateError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ updateError }}</div>
            <alert-loading v-if="retrieveLoading || updateLoading"></alert-loading>
            <InvoiceForm v-if="item && !retrieveLoading && !updateLoading" :handle-submit="handleSubmit" :values="item" :errors="violations" :initialValues="retrieved"></InvoiceForm>
        </div>
    </b-container>
</template>

<script>
  import InvoiceForm from './Form.vue';
  import { mapGetters } from 'vuex';

  export default {
    created () {
      this.reset();
      this.$store.dispatch('invoice/update/retrieve', this.$route.params.id);
    },
    components: {
      InvoiceForm
    },
    computed: {
      ...mapGetters({
        retrieveError: 'invoice/update/retrieveError',
        retrieveLoading: 'invoice/update/retrieveLoading',
        updateError: 'invoice/update/updateError',
        updateLoading: 'invoice/update/updateLoading',
        deleteError: 'invoice/del/error',
        deleteLoading: 'invoice/del/loading',
        deleted: 'invoice/del/deleted',
        retrieved: 'invoice/update/retrieved',
        updated: 'invoice/update/updated',
        violations: 'invoice/update/violations'
      })
    },
    data: function() {
      return {
        item: {}
      }
    },
    methods: {
      handleSubmit (values) {
        this.$store.dispatch('invoice/update/update', {item: this.retrieved, values: values });
      },
      del () {
        if (window.confirm('Czy na pewno chce usunąć tą fakturę?'))
          this.$store.dispatch('invoice/del/delete', this.retrieved);
      },
      reset () {
        this.$store.dispatch('invoice/update/reset');
        this.$store.dispatch('invoice/del/reset');
        this.$store.dispatch('invoice/create/reset');
      }
    },
    watch: {
      deleted: function (deleted) {
        if (deleted) {
          this.$router.push({ name: 'InvoiceList' });
        }
      },
      updated: function (created) {
          if (created) {
            this.$router.push({ name: 'InvoiceShow', params: { id: created['id']} });
          }
        }
    },
//    beforeDestroy() {
//      this.reset();
//    }
  }
</script>


// WEBPACK FOOTER //
// Update.vue?e324e7e4